import styled, { css } from 'styled-components';
export const ImagesContainer = styled.div `
  display: flex;
  gap: 8px;
  padding: 8px;

  overflow-x: scroll;
`;
export const Wrapper = styled.div `
  position: relative;
`;
export const ImageContainer = styled.div(({ theme, selected }) => css `
    min-width: 80px;
    height: 80px;

    position: relative;

    border-radius: 8px;
    overflow: hidden;

    display: flex;
    justify-content: center;
    align-items: center;

    ${selected
    ? css `
          border: 2px solid ${theme.palette.purple.main};
        `
    : css `
          border: 1px solid gray;
        `}
  `);
export const ImagePreview = styled.img `
  width: 100%;
  height: 100%;

  object-fit: cover;
`;
